/* eslint-disable */ import { memoEval, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const lynxProfessionalGrillW54Components = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'default', true).withEntity('LynxProfessionalGrillW54').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'GRILL_LYNX_PROFESSIONAL_L54',
            dimensionUnit: 'inch'
        })))
];

//# sourceMappingURL=lynx-professional-grill-w-54.js.map